import { i18n } from '@/plugins/i18n'
import { statusVariant, statusStr } from '@/constants/settlementStatus'

export default [
    {
        field: 'date',
        title: i18n.t('label.date'),
        sortable: false,
        width: 100,
    },
    {
        field: 'time',
        title: i18n.t('label.time'),
        sortable: false,
        width: 100,
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        textAlign: 'center',
        template: (row) => {
            let variant, status;
            if (row.status == 0) {
                variant   = 'badge-danger'
                status = i18n.t('label.vpn_connection_failed')
            } else {
                variant   = 'badge-success'
                status = i18n.t('label.vpn_connection_succeeded')
            }

            return '<div class="badge '+variant+' text-white">'+ status +'</div>'
        },
        sortable: false,
        width: 100,
    },
]